"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
// text field

const styleOverrides = {
  root: ({
    theme
  }) => ({
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    borderRadius: 24,
    // eslint-disable-next-line @typescript-eslint/naming-convention -- css selector
    'input::placeholder': {
      opacity: 1,
      transition: 'none'
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention -- css selector
    'label + &': {
      marginTop: theme.spacing(3)
    },
    backgroundColor: theme.palette.grey[100]
  }),
  input: {
    padding: '14px 17px'
  },
  sizeSmall: {
    paddingTop: 6,
    paddingBottom: 6
  },
  adornedStart: {
    [`& .${_material.filledInputClasses.input}`]: {
      paddingLeft: 0
    }
  },
  adornedEnd: {
    [`& .${_material.filledInputClasses.input}`]: {
      paddingRight: 0
    }
  },
  multiline: {
    [`&.${_material.filledInputClasses.sizeSmall}`]: {
      paddingTop: 6,
      paddingBottom: 6
    },
    padding: '14px 15px'
  }
};
const defaultProps = {
  disableUnderline: true,
  color: 'inputElements'
};
var _default = exports.default = {
  defaultProps,
  styleOverrides
};
